<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="pod-code-add-form-modal-label">
                {{ $root.text('Create POD code', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>
            <div v-else>
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <form v-if="$root.hasPermission('podcodes_create')" v-on:submit.prevent="onSubmit()">
                    <div class="form-group">
                        <label for="pod-code-title" id="pod-code-title-label" class="mandatory-label">
                            {{ $root.text('Title', null, true) }} *
                        </label>
                        <input
                            v-model="pod_code.title"
                            type="text"
                            id="pod-code-title"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('pod-code-title')"
                            v-on:change="$root.unHighlightErrors('pod-code-title')"
                        >
                    </div>
                    <div class="form-group">
                        <label for="pod-code-brand">{{ $root.text('Brand', null, true) }}</label>
                        <input
                            v-model="pod_code.brand"
                            type="text"
                            id="pod-code-brand"
                            class="form-control"
                            :readonly="updating"
                        >
                    </div>
                    <div class="form-group">
                        <label for="pod-code-old_code">{{ $root.text('Old code', null, true) }}</label>
                        <input
                            v-model="pod_code.old_code"
                            type="text"
                            id="pod-code-old_code"
                            class="form-control"
                            :readonly="updating"
                        >
                    </div>
                    <div class="form-group">
                        <label for="pod-code-live_date">
                            {{ $root.text('Live date', null, true) }}
                        </label>
                        <b-form-datepicker
                            v-model="pod_code.live_date"
                            id="pod-code-live_date"
                            class="form-control"
                            start-weekday="1"
                            locale="en-GB"
                            :label-no-date-selected="$root.text('No date selected', null, true)"
                            :hideHeader="true"
                            :date-format-options="{ 'day': '2-digit', 'month': '2-digit', 'year': 'numeric' }"
                            :disabled="updating"
                        ></b-form-datepicker>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="($root.hasPermission('podcodes_create') && !updated)" class="modal-footer">
            <span v-if="!updating">
                <span>
                    <button type="button" class="btn btn-primary" @click="onSubmit()">
                        <i class="far fa-check mr-1"></i> {{ $root.text('Create', null, true) }}
                    </button>
                </span>
            </span>
            <span v-else>
                <button type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Create', null, true) }}</span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                pod_code: {}
            }
        },
        mounted () {
            //
        },
        methods: {
            resetForm: function () {
                if (!this.$root.hasPermission('podcodes_create')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.errors = false;
                this.updating = false;
                this.updated = false;
                this.pod_code = {};
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                setTimeout(function () {
                    $('#pod-code-title').focus();
                }, 500);
            },
            onSubmit: function () {
                this.errors = false;
                this.updating = true;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send request to API
                 */
                const data = this.pod_code;
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/pod-code';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.updated = response.data.message;
                    vm.$parent.getPodCodes();

                    setTimeout(function () {
                        $('#pod-code-add-form-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // missing/lost API token - close modal and logout user
                            $('#pod-code-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            if (typeof error.response.data.error === 'string') {
                                vm.errors = error.response.data.error;
                            } else if (typeof error.response.data.error === 'object') {
                                vm.errors = '';
                                for (const [key, value] of Object.entries(error.response.data.error)) {
                                    vm.errors += value.join('<br>') + '<br>';
                                    $('#pod-code-' + key + '-label').addClass('text-danger');
                                    $('#pod-code-' + key).addClass('field-error');
                                }
                            }
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            }
        }
    }
</script>
